import AccountingIconImg from '../assets/img/icon/money_icon.svg';
import TaxIconImg from '../assets/img/icon/legal_icon.svg';
import ARIcon from '../assets/img/icon/sales_icon.svg';
import PayrollIcon from '../assets/img/icon/hand_money_icon.svg';
import { name } from '../config/i18n/en_us';

export const INBOX_LIST_IMAGE = {
    ACCOUNTING_DOC: AccountingIconImg,
    AR_DOCUMENT: ARIcon,
    PAYROLL_DOCUMENT: PayrollIcon,
    TAX_DOCUMENT: TaxIconImg,
    LEGAL_DOCUMENT: ARIcon,
    DEFAULT: TaxIconImg,
};

export const InboxFolderList = [{
    name: 'FOLDER_QUICKBOOKS_FILE',
    imgSrc: INBOX_LIST_IMAGE.AR_DOCUMENT,
    status: true,
    category: 'ffda_folders',
    isBucket: true,
    id: 'FFDA_QUICKBOOKS_BUCKET', // isBuekt = true
},{
    name: 'FOLDER_ACCOUNTING',
    imgSrc: INBOX_LIST_IMAGE.ACCOUNTING_DOC,
    constant: "folder_accounting",
    status: false,
}, {
    name: 'FOLDER_AR',
    imgSrc: INBOX_LIST_IMAGE.AR_DOCUMENT,
    constant: "account_receivable",
    status: false,
}, {
    name: 'FOLDER_PAYROLL',
    imgSrc: INBOX_LIST_IMAGE.PAYROLL_DOCUMENT,
    constant: "payroll",
    status: false,
}, {
    name: 'FOLDER_TAX',
    imgSrc: INBOX_LIST_IMAGE.TAX_DOCUMENT,
    constant: "tax_return_documents",
    status: false,
}];

export const InboxFolderListDictionary = InboxFolderList.reduce((memo, elm) => {
    memo[elm.name] = elm;
    return memo;
}, {});
